import React from "react";
import MembershipRetentionRateChartView from "../../features/MetabaseDashboard/MembershipRetentionRateChartView";

const MembershipRetentionRateChart = () => {
  return (
    <div>
      <MembershipRetentionRateChartView />
    </div>
  );
};

export default MembershipRetentionRateChart;
